import type { IFinancialCockpitActualsAndTargetsSetting } from '../api/types'
import type { ICockpitCategoryOption, TCockpitCategoriesByOffering } from '../model/types'

export const getCockpitCategoriesByOffering = (
  settings: IFinancialCockpitActualsAndTargetsSetting[]
): TCockpitCategoriesByOffering => {
  const categoriesByOffering = new Map<string, Map<string, ICockpitCategoryOption>>()

  settings.forEach(({ ProgramType, Category, CategoryOrder, IsMainHierarchy }) => {
    const offering = ProgramType.trim()
    const category = Category.trim()

    if (!offering || !category || IsMainHierarchy !== 1) {
      return
    }

    const categories = categoriesByOffering.get(offering) ?? new Map()
    const existingCategory = categories.get(category)

    if (!existingCategory || CategoryOrder < existingCategory.order) {
      categories.set(category, { category, order: CategoryOrder })
    }

    categoriesByOffering.set(offering, categories)
  })

  return Object.fromEntries(
    Array.from(categoriesByOffering, ([offering, categories]) => [
      offering,
      Array.from(categories.values()).sort(
        (left, right) => left.order - right.order || left.category.localeCompare(right.category)
      ),
    ])
  ) as TCockpitCategoriesByOffering
}
